import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  getSavedCustomerToken,
  getCurrentCustomer,
  clearCustomerSession
} from '@/lib/shopifyCustomer';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const timeout = setTimeout(() => {
      if (!cancelled) {
        clearCustomerSession();
        setIsAllowed(false);
        setLoading(false);
      }
    }, 8000);

    async function validateAccess() {
      try {
        const token = getSavedCustomerToken();

        if (!token) {
          if (!cancelled) {
            setIsAllowed(false);
            setLoading(false);
          }
          return;
        }

        const customer = await getCurrentCustomer(token);

        if (!cancelled) {
          if (!customer) {
            clearCustomerSession();
            setIsAllowed(false);
          } else {
            setIsAllowed(true);
          }
          setLoading(false);
        }
      } catch (error) {
        if (!cancelled) {
          clearCustomerSession();
          setIsAllowed(false);
          setLoading(false);
        }
      }
    }

    validateAccess();

    return () => {
      cancelled = true;
      clearTimeout(timeout);
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen pt-24 pb-16 px-6">
        <div className="max-w-[1000px] mx-auto flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
        </div>
      </div>
    );
  }

  if (!isAllowed) {
    const redirect = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
